import React, { useContext } from "react";
import "./BoardOfDirectors.css";
import { LanguageContext } from "../../context/LanguageContext";

// Import board charts for both Arabic and English
import chartAr from "../../assets/org_chart_falcom_holding_ar.svg";
import chartEn from "../../assets/org_chart_falcom_holding_en.svg";

const BoardOfDirectors = () => {
  const { language } = useContext(LanguageContext); // Get current language from context

  return (
    <div className="board-page" dir={language === "ar" ? "rtl" : "ltr"}>
      {/* Wrapper for fade-in animation on language switch */}
      <div className="fade-transition" key={language}>
        {/* Section title */}
        <h2 className="board-title">
          {language === "ar" ? "مجلس الإدارة" : "Board of Directors"}
        </h2>

        {/* orange line below title */}
        <div className="orange-line-board"></div>

        {/* Org chart image (language-based) */}
        <div className="chart-container">
          <img
            src={language === "ar" ? chartAr : chartEn}
            alt="Board Chart"
          />
        </div>
      </div>
    </div>
  );
};

export default BoardOfDirectors;
